import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface MenuInfo {
  companyName: string
  site?: any
}
export interface MenuInfoState {
  isLoading: boolean
  loadingError: string | null
  menuInfo: MenuInfo[] | null
  httpStatus: number | null
}
export const initialState: MenuInfoState = {
  isLoading: true,
  loadingError: null,
  menuInfo: null,
  httpStatus: null
}

const menuInfoSlice = createSlice({
  name: 'menuInfoSlice',
  initialState,
  reducers: {
    menuInfoLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        menuInfo: null,
        httpStatus: 0
      }
    },
    menuInfoUpdateAction: (state, action: PayloadAction<{ data: MenuInfo[], httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        menuInfo: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    menuInfoErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        menuInfo: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  menuInfoLoadingAction,
  menuInfoUpdateAction,
  menuInfoErrorAction
} = menuInfoSlice.actions

export default menuInfoSlice.reducer
